import React from 'react';
import PropTypes from 'prop-types';
import { Stack } from '@mui/material';
import Select from 'components/select';
import { useRecoilState } from 'recoil';
import { OrderPayload } from 'pages/myidm/store';
import ProvisioningStyles from 'pages/provisioning/vm/style';
import { endPoints } from 'api/endpoints';
import axios from 'api/request';
import { useMutation } from 'react-query';

const CloudType = ({ index }) => {
    const [isTouched, setIsTouched] = React.useState(false);
    const [order, setOrder] = useRecoilState(OrderPayload);
    const [options, setOptions] = React.useState([]);
    const cloudTypeApi = useMutation(() => axios.get(endPoints.aws.lookups.cloudType));

    const currentValue = index !== undefined ? order?.multipleResourceGroups?.[index]?.cloudType : order?.cloudType;

    const setCloudType = (cloudType, cloudTypeDetails) => {
        const updatedGroups = [...(order?.multipleResourceGroups || [])];
        updatedGroups[index] = {
            ...updatedGroups[index],
            cloudType,
            cloudTypeDetails,
        };
        setOrder({
            ...order,
            multipleResourceGroups: updatedGroups,
        });
    };

    const handleOnSelectChange = (selected) => {
        setCloudType(selected.value, selected);
    };

    const resetOptions = () => {
        setOptions([]);
    };

    const isExistsInOptions = (cloudType) => options.find((option) => cloudType === option.value);

    React.useEffect(() => {
        if (cloudTypeApi?.isSuccess) {
            setOptions(
                (cloudTypeApi?.data?.data?.cloudTypes || cloudTypeApi?.data?.data || []).map((app) => ({
                    label: typeof app === 'string' ? app : app?.cloudTypeDisplayName,
                    value: typeof app === 'string' ? app : app?.cloudTypeBackendName,
                    data: app,
                }))
            );
        }
    }, [cloudTypeApi?.isSuccess]);

    React.useEffect(() => {
        if (options && options?.length === 1 && !currentValue) {
            setCloudType(options?.[0].value, options?.[0]);
        }
        if (options && options?.length && currentValue) {
            const matched = isExistsInOptions(currentValue);
            if (matched) setCloudType(matched.value, matched);
        }
    }, [options]);

    React.useEffect(() => {
        resetOptions();
        cloudTypeApi.mutate();
    }, []);

    React.useEffect(() => {
        if (!currentValue && order?.isTouched) setIsTouched(true);
        else setIsTouched(false);
    }, [currentValue, order?.isTouched]);

    return (
        <Stack direction="row" spacing={1} sx={ProvisioningStyles.stack}>
            <Select
                sx={{ marginTop: 0 }}
                key={`cloud-type-${index !== undefined ? index : 'single'}`}
                label="Cloud Type *"
                value={options.find((option) => option.value === currentValue) || null}
                options={options}
                handleOnSelect={(value) => handleOnSelectChange(value)}
                isRequired={isTouched}
                disabled={cloudTypeApi.isLoading || (options?.length === 1 && !!currentValue)}
                isLoading={cloudTypeApi.isLoading}
                isOptionEqualToValue={(option, selectedValue) => option.value === selectedValue.value}
            />
        </Stack>
    );
};

CloudType.propTypes = {
    index: PropTypes.number,
};

CloudType.defaultProps = {
    index: undefined,
};

export default CloudType;
